export const GET_CRITERIA_DATA= 'GET_CRITERIA_DATA';
export const GET_RECORDS_DATA= 'GET_RECORDS_DATA';
export const GET_REPORTS_DATA= 'GET_REPORTS_DATA';
